import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-h5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.mutableDialogSwitch,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mutableDialogSwitch) = $event)),
    "onClick:outside": _ctx.closeDialog,
    transition: "dialog-top-transition",
    "max-width": "1200",
    "max-height": "1200",
    "retain-focus": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, {
            color: "secondary",
            elevation: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Access Request For " + _toDisplayString(_ctx.suppliedAccessRequest.userName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                class: "text-white",
                icon: "mdi-close-outline",
                density: "comfortable",
                variant: "plain",
                onClick: _ctx.closeDialog
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_card_text, { class: "mt-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                modelValue: _ctx.isFormValid,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isFormValid) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { style: {"margin-left":"46%"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_avatar, {
                            color: "#FF7F50",
                            class: "text-white",
                            size: "x-large"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.suppliedAccessRequest.firstName.charAt(0) + _ctx.suppliedAccessRequest.lastName.charAt(0)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            readonly: _ctx.isReadOnlyState,
                            modelValue: _ctx.mutableAccessRequest.email,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mutableAccessRequest.email) = $event)),
                            label: "Email",
                            rules: _ctx.requiredFieldRules
                          }, null, 8, ["readonly", "modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        offset: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            readonly: _ctx.isReadOnlyState,
                            modelValue: _ctx.mutableAccessRequest.phone,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mutableAccessRequest.phone) = $event)),
                            label: "Phone",
                            maxlength: "12",
                            counter: ""
                          }, null, 8, ["readonly", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            readonly: _ctx.isReadOnlyState,
                            modelValue: _ctx.mutableAccessRequest.firstName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mutableAccessRequest.firstName) = $event)),
                            label: "First Name",
                            maxlength: "50",
                            counter: "",
                            rules: _ctx.requiredFieldRules
                          }, null, 8, ["readonly", "modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            readonly: _ctx.isReadOnlyState,
                            modelValue: _ctx.mutableAccessRequest.lastName,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mutableAccessRequest.lastName) = $event)),
                            label: "Last Name",
                            maxlength: "50",
                            counter: "",
                            rules: _ctx.requiredFieldRules
                          }, null, 8, ["readonly", "modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            readonly: _ctx.isReadOnlyState,
                            modelValue: _ctx.mutableAccessRequest.userName,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mutableAccessRequest.userName) = $event)),
                            label: "Username",
                            maxlength: "50",
                            counter: "",
                            rules: _ctx.requiredFieldRules
                          }, null, 8, ["readonly", "modelValue", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                          _cache[9] || (_cache[9] = _createElementVNode("p", null, [
                            _createElementVNode("b", null, "Requested Roles:")
                          ], -1)),
                          _createVNode(_component_v_select, {
                            readonly: _ctx.isReadOnlyState,
                            modelValue: _ctx.requestedRoleIds,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestedRoleIds) = $event)),
                            items: _ctx.selectableRoles,
                            "item-value": "roleId",
                            "item-title": "description",
                            multiple: "",
                            rules: _ctx.atLeastOneRules,
                            menu: _ctx.isFocused
                          }, null, 8, ["readonly", "modelValue", "items", "rules", "menu"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        offset: "4"
                      }, {
                        default: _withCtx(() => [
                          _cache[10] || (_cache[10] = _createElementVNode("p", null, [
                            _createElementVNode("b", null, "Requested Treatment Programs:")
                          ], -1)),
                          _createVNode(_component_v_select, {
                            readonly: _ctx.isReadOnlyState,
                            modelValue: _ctx.requestedProgramIds,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestedProgramIds) = $event)),
                            items: _ctx.selectableTreatmentPrograms,
                            "item-value": "treatmentProgramId",
                            "item-title": "description",
                            multiple: "",
                            rules: _ctx.atLeastOneRules,
                            menu: _ctx.isFocused
                          }, null, 8, ["readonly", "modelValue", "items", "rules", "menu"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "justify-start" }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                color: "success",
                onClick: _ctx.approveRequest
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" Approve ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_ripple]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                color: "error",
                onClick: _ctx.rejectRequest
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" Reject ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_ripple]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                color: "info",
                onClick: _ctx.modifyRequest
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode(" Modify ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_ripple]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onClick:outside"]))
}